import styled from "styled-components";
import {
  spacing,
  color,
  borderRadius,
  palette,
  typography,
} from "@conserveit/blocks";
import { TYPOGRAPHY } from "../../../AppChrome/App.constants";

// NOTE: For legacy add comment component
import {
  AttachmentPreviewItem,
  RemoveButton,
} from "../../../AttachmentsPreview/AttachmentsPreview.styled";

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 400px;
  border-left: 1px solid ${color.theme.divider.solid};
  border-top: 1px solid ${color.theme.divider.solid};
  background-color: white;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.tight} ${spacing.extraTight} ${spacing.tight}
    ${spacing.default};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1;
`;

export const EditLink = styled.a`
  color: ${color.theme.primaryColor.action.primary};
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-position: under;
`;

export const SiteTitle = styled.h3`
  margin: 0 0 ${spacing.extraTight};
  font-size: 18px;
  font-weight: ${TYPOGRAPHY.WEIGHTS.REGULAR};
  color: ${color.theme.typography.ink};

  span {
    display: inline-block;
    padding-left: ${spacing.tight};
    color: ${palette.neutral6};
  }
`;

export const Content = styled.div`
  padding: ${spacing.default};
  padding-top: 56px;
  height: 100%;
  overflow-y: auto;
`;

export const CreatedUpdatedText = styled.p`
  font-size: 14px;
  color: ${palette.neutral8};
  margin-bottom: ${spacing.snug};
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: ${spacing.loose};
`;

export const Section = styled.div`
  margin-bottom: ${spacing.loose};

  .Issue-description {
    color: ${palette.neutral8};
    margin-bottom: ${spacing.default};
  }
`;

export const SectionHeading = styled.h4`
  font-size: 14px;
  font-weight: ${TYPOGRAPHY.WEIGHTS.BOLD};
  text-transform: uppercase;
  margin: ${spacing.tight} 0;
`;

export const SavingsCard = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: ${spacing.tight};
  padding: ${spacing.tight} ${spacing.default};
  background-color: ${color.pureWhite};
  border: 1px solid ${color.theme.divider.solid};
  margin-bottom: ${spacing.loose};

  ${SectionHeading}, p {
    font-size: 12px;
  }
`;

// TODO: This is duplicated
export const EquipList = styled.ul`
  margin: 0 0 ${spacing.snug} 0;
  padding-left: ${spacing.loose};

  li:empty {
    display: none;
  }
`;

/**
 * HACK: This is a huge gross hack that should be addressed ASAP when the
 * comments system is revisted.
 */
export const WrapLegacyAddComment = styled.div`
  padding: ${spacing.snug};
  background-color: ${color.pureWhite};
  border-radius: ${borderRadius.default};
  border: 1px solid ${color.theme.divider.solid};
  ${typography.body}
  /* Change layout of components */
  .col-xs-12 {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    font-size: 0px;
  }

  label {
    margin-top: ${spacing.default};
  }

  .form-group {
    margin: 0;
    display: flex;
    flex-direction: column-reverse;
  }

  & > div {
    border: 0;
  }

  ${AttachmentPreviewItem} {
    margin-top: ${spacing.default};
    margin-bottom: 0;
  }

  ${RemoveButton} {
    color: ${color.theme.icon.subdued};
  }
`;
